import { render, staticRenderFns } from "./LoanMerge.vue?vue&type=template&id=25a4a908&scoped=true"
import script from "./LoanMerge.vue?vue&type=script&lang=js"
export * from "./LoanMerge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4a908",
  null
  
)

export default component.exports